import React, { useRef, useState } from "react";
import MaterialReactTable from "material-react-table";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Paper,
  Box,
  Button,
  MenuItem,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as ViewIcon,
} from "@mui/icons-material";
import { useAuthHeader, useAuthUser } from "react-auth-kit";
import columns from "./MonitorAlertColumns";
import {
  LoadingPaper,
  LoadingError,
  EmptyPaper,
} from "../../components/LoadingComponents";
import { useGetRecap } from "../../components/ReportComponents";
import { ViewPatient } from "../../components/PatientComponents";

function MonitorAlert() {
  const authUser = useAuthUser();

  // === web service queries/mutations ===
  const recapQuery = useGetRecap();

  // === ViewPatient modal handling ===
  const [openViewPatient, setOpenViewPatient] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const handleOpenViewPatient = (patient_id) => {
    setSelectedPatient(patient_id);
    setOpenViewPatient(true);
  };
  const handleCloseViewPatient = () => {
    setOpenViewPatient(false);
  };

  const tableColumns = columns;

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openViewPatient} fullScreen>
        <ViewPatient
          _editMode={false}
          patient_id={selectedPatient}
          closeModal={handleCloseViewPatient}
        />
      </Dialog>

      <PageTitle title="Monitor Alert" />
      {recapQuery.isLoading ? (
        <LoadingPaper />
      ) : recapQuery.isError ? (
        <LoadingError error={recapQuery.error} />
      ) : (
        recapQuery.isSuccess && (
          <Paper style={{ minHeight: "40%", margin: "3vh", maxWidth: "96%" }}>
            {recapQuery.data.length === 0 ? (
              <EmptyPaper message={"Nessun recap disponibile"} />
            ) : (
              <MaterialReactTable
                columns={tableColumns}
                data={
                  recapQuery.data?.map((patient) => {
                    return { ...patient };
                  }) || []
                }
                initialState={{
                  density: "compact",
                  showColumnFilters: true,
                }}
                enablePagination={true}
                enableBottomToolbar={true}
                enableTopToolbar={false}
                enableSorting={true}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                enableColumnResizing
                enableColumnActions={false}
                enableRowSelection={false}
                muiTableContainerProps={{
                  sx: {
                    overflowX: "hidden",
                  },
                }}
                enableRowActions={true}
                displayColumnDefOptions={{
                  "mrt-row-actions": { header: "Azioni" },
                }}
                positionActionsColumn="last"
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      key="view"
                      onClick={() => {
                        handleOpenViewPatient(row.original.patient_id);
                      }}
                      color="primary"
                    >
                      <ViewIcon />
                    </IconButton>
                  </Box>
                )}
              />
            )}
          </Paper>
        )
      )}
    </main>
  );
}

export default MonitorAlert;
